import { supabase } from '@/lib/supabase'

/**
 * Minimal authenticated GET wrapper for the platform API.
 *
 * Pulls the Supabase access token from the current session and sends it as a
 * Bearer token. Paths are relative (e.g. '/api/v1/nda'); the dev Vite proxy and
 * staging nginx both serve '/api' from the backend.
 */
export async function apiGet<T>(path: string): Promise<T> {
  const {
    data: { session },
  } = await supabase.auth.getSession()

  const headers: Record<string, string> = { Accept: 'application/json' }
  if (session?.access_token) {
    headers.Authorization = `Bearer ${session.access_token}`
  }

  const response = await fetch(path, { headers })
  if (!response.ok) {
    throw new Error(`Verzoek mislukt (${response.status})`)
  }
  return (await response.json()) as T
}
